import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Target } from 'lucide-react';
import type { ManagerIntelligenceStats } from '@/hooks/useManagerIntelligenceStats';

interface Props { stats: ManagerIntelligenceStats | null | undefined; isSelfView: boolean; }

export function ManagerInterventionEffectiveness({ stats }: Props) {
  const formatRate = (r: number | null) => r != null ? `${Math.round(r * 100)}%` : '—';
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2"><Target className="h-5 w-5" />Intervention Effectiveness</CardTitle>
        <CardDescription>How well schedule overrides and interventions improve outcomes</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-3 bg-muted/30 rounded-lg space-y-2">
          <div className="flex justify-between text-sm"><span>Override Improvement Rate</span><span className="font-semibold">{formatRate(stats?.overrideImprovementRate)}</span></div>
          {stats?.overrideImprovementRate != null && <Progress value={stats.overrideImprovementRate * 100} className="h-2" />}
        </div>
        <div className="p-3 bg-muted/30 rounded-lg space-y-2">
          <div className="flex justify-between text-sm"><span>Instinct Accuracy</span><span className="font-semibold">{formatRate(stats?.instinctAccuracy)}</span></div>
          {stats?.instinctAccuracy != null && <Progress value={stats.instinctAccuracy * 100} className="h-2" />}
        </div>
      </CardContent>
    </Card>
  );
}
